import { isSpecificDate } from "src/util";
import AprilFoolsImage from "src/resources/bart_april_1st.png";
import HalloweenImage from "src/resources/bart_oct_31st.png";

export interface FestivalEasterEgg {
  /** Human-readable name, for readability/debugging. */
  readonly name: string;
  /** 1-indexed month (1 = January, 12 = December). */
  readonly month: number;
  /** Day of the month. */
  readonly day: number;
  /** How many days before the date the egg starts showing (0 = day only). */
  readonly leadDays: number;
  /** Square Bart image used as both the header logo and the favicon. */
  readonly image: string;
}

/**
 * Festival easter-egg logos/favicons, shown on (or shortly before) specific
 * dates. To add another, append an entry here — no other code changes needed.
 * If two windows ever overlap, the earlier entry wins.
 */
export const FESTIVAL_EASTER_EGGS: readonly FestivalEasterEgg[] = [
  {
    name: "April Fools' Day",
    month: 4,
    day: 1,
    leadDays: 0,
    image: AprilFoolsImage,
  },
  { name: "Halloween", month: 10, day: 31, leadDays: 7, image: HalloweenImage },
];

/**
 * Returns the easter egg active for the given date, or undefined if none.
 */
export const getActiveFestivalEasterEgg = (
  now: Date = new Date(),
): FestivalEasterEgg | undefined =>
  FESTIVAL_EASTER_EGGS.find((egg) =>
    isSpecificDate(egg.month, egg.day, egg.leadDays, now),
  );
